
import { defineComponent  } from "vue";

type Props = {
  text: string
};

export default defineComponent({
  name: "QuoteLine",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const lineWindow = () => {
      let url = `http://line.me/R/msg/text/?${props.text}${window.location.href}`;
      let width = 500;
      let height = 550;
      let features = "location=no, menubar=no, status=yes, scrollbars=yes, resizable=yes, toolbar=no";
      features += ", left=" + (window.screen.width - width) / 2;
      features += ", width=" + width;
      features += ", top=" + (window.screen.height - height) / 2;
      features += ", height=" + height;

      window.open(url, "_blank", features);
    };
    return {
      lineWindow
    };
  }
});
